import { compareVersions } from 'compare-versions';
import { DESKTOP_FILE_SYNC_MIN_VERSION } from '../constants';

export const isDesktopFileSyncSupportedToDesktopVersion = (version: string | null) => {
  if (!version) {
    return false;
  }

  return compareVersions(version, DESKTOP_FILE_SYNC_MIN_VERSION) >= 0;
};
